import { ScrollReveal } from "./Reveal";

export const StatementSection = () => (
  <section data-testid="statement-section" className="py-28 lg:py-40 bg-[#111111] border-y border-white/10">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <ScrollReveal>
        <h2 className="font-display leading-[0.95] text-[9vw] sm:text-[7vw] lg:text-[5.5vw] max-w-5xl" data-testid="statement-heading">
          Every business has a story. Most people just don't know how to tell it.
        </h2>
      </ScrollReveal>
      <ScrollReveal delay={0.15}>
        <div className="mt-12 lg:mt-16 grid lg:grid-cols-2 gap-8 items-end">
          <p className="text-base md:text-lg text-[#8A8A85] leading-relaxed max-w-xl">
            I don't just turn up with a camera. I help turn an idea, business,
            event or personal journey into something people can actually feel.
            From the first shot to the final edit, every project is built around
            story, emotion and attention.
          </p>
          <p className="font-display text-4xl lg:text-5xl text-outline lg:text-right select-none">Etia</p>
        </div>
      </ScrollReveal>
    </div>
  </section>
);
